import $ from 'jquery'
import 'owl.carousel'
import 'magnific-popup'
import LazyLoad from 'vanilla-lazyload'

// height windows for ios
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);



// header
(function () {
    const header = $('.header'),
        burger = header.find('.header__burger'),
        wrapper = header.find('.header__wrapper'),
        items = header.find('.header__item'),
        boxs = header.find('.header__box');

    items.each(function () {
        let item = $(this),
            head = item.find('.header__head'),
            body = item.find('.header__body');

        head.on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
            if (!item.hasClass('active')) {
                items.removeClass('active');
                item.addClass('active');
                header.addClass('active')
            } else {
                items.removeClass('active');
                header.removeClass('active')
            }
        });

        $('.header__body > .header__back').on('click', function () {
            header.removeClass('active')
            items.removeClass('active');
        });
    });

    boxs.each(function () {
        let box = $(this),
            top = box.find('.header__top'),
            wrap = box.find('.header__wrap');

        top.on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
            if (!box.hasClass('active')) {
                boxs.removeClass('active');
                box.addClass('active');
            } else {
                boxs.removeClass('active');
            }
        });

        $('.header__box .header__back').on('click', function () {
            boxs.removeClass('active');
        });
    });

    burger.on('click', function (e) {
        e.stopPropagation();
        burger.toggleClass('active');
        wrapper.toggleClass('visible');
        items.removeClass('active');
        boxs.removeClass('active');
    });

    wrapper.on('click', function (e) {
        e.stopPropagation();
    });

    $('.header__search a').click(function () {
        header.toggleClass('active')
        $('.header__finder').toggleClass('on')
    })

    $('html, body').on('click', function () {
        burger.removeClass('active');
        wrapper.removeClass('visible');
        items.removeClass('active');
        boxs.removeClass('active');
        header.removeClass('active')
        $('.header__finder').removeClass('on')
    });

}());

// language
(function () {
    const language = $('.language'),
        head = language.find('.language__head'),
        body = language.find('.language__body');

    head.on('click', function (e) {
        e.stopPropagation();
        language.toggleClass('active');
    });

    $('html, body').on('click', function () {
        language.removeClass('active');
    });

    body.on('click', function (e) {
        e.stopPropagation();
    });

}());

// carousel arrows
const navArrows = [
    `<svg xmlns="http://www.w3.org/2000/svg" width="36" height="13" viewBox="0 0 36 13"><path d="M6.147 12.854l-6-6-.01-.009c-.014-.014-.027-.03-.039-.046l.048.055a.5.5 0 0 1-.062-.076.35.35 0 0 1-.031-.05c-.003-.008-.007-.016-.01-.023-.009-.018-.016-.037-.022-.056-.001-.008-.003-.015-.005-.022-.006-.02-.01-.041-.013-.062L0 6.501l.002-.022.001-.021L0 6.501a.5.5 0 0 1 .125-.331l.011-.012L6.147.147A.5.5 0 0 1 6.5.001a.5.5 0 0 1 .354.853L1.707 6.001H35.5a.5.5 0 1 1 0 1H1.708l5.146 5.146a.5.5 0 0 1-.707.707z"  fill="#009dbb"/></svg>`,
    `<svg xmlns="http://www.w3.org/2000/svg" width="36" height="13" viewBox="0 0 36 13"><path d="M29.853.147l6 6 .01.009c.014.014.027.03.039.046l-.048-.055a.5.5 0 0 1 .062.076.35.35 0 0 1 .031.05c.003.008.007.016.01.023.009.018.016.037.022.056.001.008.003.015.005.022.006.02.01.041.013.062L36 6.5l-.002.022-.001.021L36 6.5a.5.5 0 0 1-.125.331l-.011.012-6.011 6.011a.5.5 0 0 1-.815-.162.5.5 0 0 1 .108-.545L34.293 7H.5a.5.5 0 1 1 0-1h33.792L29.146.854a.5.5 0 0 1 0-.707.5.5 0 0 1 .707 0z" fill="#009dbb"/></svg>`];

// sliders
(function () {

    // offers
    $('.js-offers-slider').each(function (i, el) {
        var id = $(el).data('id')
        var selector = id == null ? '.offers__controls' : `.offers__controls[data-id="${id}"]`
        $(el).owlCarousel({
            items: 3,
            nav: true,
            navContainer: selector,
            navText: navArrows,
            dots: false,
            smartSpeed: 700,
            responsive: {
                0: {
                    items: 1,
                },
                666: {
                    items: 2,
                },
                1024: {
                    items: 3,
                },
            }
        })
    });

    // slider
    const slider = $('.js-slider'),
        next = $('.slider__next'),
        numberValue = $('.slider__counter');

    slider.owlCarousel({
        items: 1,
        loop: true,
        dots: false,
        smartSpeed: 700,
        autoHeight: true,
        onInitialized: counter,
        onTranslated: counter
    });


    next.click(function () {
        slider.trigger('next.owl.carousel');
    })

    function counter(event) {
        let element = event.target,
            items = parseInt(element.dataset.count),
            item = event.item.index - 1;

        if (item > items) {
            item = item - items;
        }

        numberValue.html(item + " / " + items);
    }

})();


// information
(function () {
    const head = $('.information__head')
    head.on('click', function () {
        if (window.innerWidth < 1024) {
            $(this).toggleClass('active');
            $(this).next().slideToggle();
        }
    });
}());

document.addEventListener('mousemove', function () {
    document.documentElement.classList.remove('nomouse')
})

$('.hero.video video').each(function () {
    var $elem = $(this)
    if (window.innerWidth > 768) {
        $elem.attr('preload', 'auto')
        this.autoplay = true
        this.load()
        this.play()
    }
})



// details page article more
$('.details__more').on('click', function (e) {
    e.preventDefault();
    $(this).hide();
    $(this).parents('.details__article').find('.details__description p').show();
});


// scroll up
$(".js-scroll").click(function () {
    $("html, body").animate({
        scrollTop: $($(this).attr("href")).offset().top + "px"
    }, {
        duration: 1000
    });
    return false;
});

var llcallback_loaded = function (element) {
    if (element.classList.contains('hero__image')) {
        element.parentNode.classList.add('loaded')
    }
}
window.lazyLoad = new LazyLoad({
    callback_loaded: llcallback_loaded,
    elements_selector: '[data-src], [data-srcset], [data-bg]'
})


window.initGTranslate = function () {
    new google.translate.TranslateElement({
        pageLanguage: 'en',
        autoDisplay: false
    }, 'gtranslate')
    window.setFlag()
}

window.GTranslateFireEvent = function (el, name) {
    try {
        if (document.createEvent) {
            var ev = document.createEvent('HTMLEvents')
            ev.initEvent(name, true, true)
            el.dispatchEvent(ev)
        } else {
            var ev = document.createEventObject()
            el.fireEvent('on' + name, ev)
        }
    } catch (e) { }
}
window.doGTranslate = function (lang) {
    var combo = document.querySelector('#gtranslate select')
    if (combo == null) {
        window.setTimeout(function () {
            window.doGTranslate(lang)
        }, 500)
    } else {
        combo.value = lang
        GTranslateFireEvent(combo, 'change')
        window.setFlag()
    }
}

window.setFlag = function () {
    var combo = document.querySelector('#gtranslate select')
    if (combo == null || combo.value == '') {
        window.setTimeout(function () {
            window.setFlag()
        }, 500)
    } else {
        var headImg = document.querySelector('.language__head .language__flag img')
        headImg.src = '/public/img/flag-' + combo.value + '.png'
    }
}